/* VIPet Store — side cart extras.
   Adds a free-shipping progress bar under the cart drawer title and a
   "continue shopping" link under the checkout button. The threshold comes
   from the shop metafield vipet.free_shipping_threshold (rendered into
   <meta name="vipet-free-ship">): blank = no bar, 0 = free shipping on
   everything, otherwise the amount in shekels. The drawer re-renders its
   own markup on every cart change, so both extras are re-attached whenever
   that happens. */
(function () {
  var meta = document.querySelector('meta[name="vipet-free-ship"]');
  var raw = meta ? (meta.getAttribute('content') || '').trim() : '';
  var threshold = raw === '' || isNaN(Number(raw)) ? null : Number(raw);

  function drawer() { return document.querySelector('cart-drawer'); }

  function money(agorot) {
    var n = Math.ceil(agorot / 100);
    return '₪' + n.toLocaleString('he-IL');
  }

  function shipBar(cart) {
    var el = document.createElement('div');
    el.className = 'vpc-ship';
    var pct, text;
    if (threshold === 0) {
      pct = 100;
      text = '🚚 משלוח חינם על כל ההזמנות!';
    } else {
      var goal = threshold * 100;
      var left = goal - cart.total_price;
      pct = Math.max(0, Math.min(100, (cart.total_price / goal) * 100));
      text = left <= 0
        ? '🎉 יש לכם משלוח חינם!'
        : 'עוד <strong>' + money(left) + '</strong> והמשלוח עלינו 🚚';
    }
    el.innerHTML =
      '<p class="vpc-ship__text">' + text + '</p>' +
      '<div class="vpc-ship__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '">' +
      '<div class="vpc-ship__fill" style="width:' + pct.toFixed(1) + '%"></div>' +
      '<span class="vpc-ship__paw" style="inset-inline-start:calc(' + pct.toFixed(1) + '% - 11px)" aria-hidden="true">🐾</span>' +
      '</div>';
    if (pct >= 100) el.classList.add('is-done');
    return el;
  }

  function continueLink() {
    var a = document.createElement('a');
    a.href = '#';
    a.className = 'vpc-continue';
    a.textContent = 'המשיכו בקניות';
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var d = drawer();
      if (d && typeof d.close === 'function') d.close();
    });
    return a;
  }

  var busy = false;
  var pending = false;

  function refresh() {
    var d = drawer();
    if (!d) return;
    if (busy) { pending = true; return; }
    busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inner = d.querySelector('.drawer__inner');
        if (!inner) return;

        var old = inner.querySelector('.vpc-ship');
        if (old) old.remove();
        var header = inner.querySelector('.drawer__header');
        if (threshold !== null && cart.item_count > 0 && header) {
          header.insertAdjacentElement('afterend', shipBar(cart));
        }

        var ctas = inner.querySelector('.cart__ctas');
        if (ctas && !inner.querySelector('.vpc-continue')) {
          ctas.insertAdjacentElement('afterend', continueLink());
        }
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (pending) { pending = false; refresh(); }
      });
  }

  function isOurs(node) {
    return node.nodeType === 1 && (node.classList.contains('vpc-ship') || node.classList.contains('vpc-continue'));
  }

  function watch() {
    var d = drawer();
    if (!d) return;
    var t = null;
    new MutationObserver(function (list) {
      var relevant = list.some(function (m) {
        if (m.type === 'attributes') return true;
        var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
        return nodes.some(function (n) { return !isOurs(n); });
      });
      if (!relevant) return;
      clearTimeout(t);
      t = setTimeout(refresh, 60);
    }).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    refresh();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();
})();
